import { ConfigurationProfileResolverActions, ConfigurationProfileApiActions } from './configuration-profile.actions';
import { Injectable } from '@angular/core';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
@Injectable()
export class ConfigurationProfileEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  configurationProfileRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(ConfigurationProfileResolverActions.configurationProfilesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getConfigurationProfiles(udid, '2.0'),
          (profiles) =>
            ConfigurationProfileApiActions.configurationProfilesLoaded({
              configurationProfiles: profiles.map((profile) => ({
                ...profile,
                udid: udid,
              })),
            }),
          (error) => ConfigurationProfileApiActions.configurationProfilesLoadedError({ error })
        )
      )
    );
  });
}
